module.exports = "pegasus/assets/theme3/arrow.png";